export default [
  {
    path: "/contratos",
    component: () => import("@/views/contratosCliente/Listar.vue"),
  },
  {
    path: "/contratos/crear",
    component: () => import("@/views/contratosCliente/Crear.vue"),
  },
  {
    path: "/contratos/editar/:id",
    component: () => import("@/views/contratosCliente/Editar.vue"),
  },
  {
    path: "/contratos/cliente/:id",
    component: () => import("@/views/contratosCliente/ListarContratosCliente.vue"),
  },
];
